// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-bg {
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  background-image: url(https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/V-_oS6r-i7wAAAAAAAAAAAAAFl94AQBr);
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
.login-bg .login-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  line-height: 44px;
  inset-block-start: 2px;
  font-weight: 600;
  font-size: 33px;
  margin: 60px 0 40px 0;
}
.login-bg .login-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-inline: 32px;
  padding-block: 24px;
  overflow: auto;
  background: inherit;
  align-items: center;
}
.login-bg .login-wrap {
  flex: 1 1 0%;
  padding: 32px 0px;
}
.login-bg .login-form {
  width: 328px;
  min-width: 280px;
  max-width: 75vw;
}
.beian {
  text-align: center;
  color: #aaa;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/index.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,8BAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,2GAAA;EACA,kCAAA;EACA,0BAAA;AADJ;AARA;EAYQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AADR;AAnBA;EAuBQ,aAAA;EACA,OAAA;EACA,sBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAFR;AA7BA;EAkCQ,YAAA;EACA,iBAAA;AAFR;AAjCA;EAuCQ,YAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAQA;EACI,kBAAA;EACA,WAAA;AANJ","sourcesContent":["\n\n.login-bg {\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100vh;\n    overflow: auto;\n    background-image: url(https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/V-_oS6r-i7wAAAAAAAAAAAAAFl94AQBr);\n    -webkit-background-size: 100% 100%;\n    background-size: 100% 100%;\n\n    .login-title {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 44px;\n        line-height: 44px;\n        inset-block-start: 2px;\n        font-weight: 600;\n        font-size: 33px;\n        margin: 60px 0 40px 0;\n    }\n    .login-container {\n        display: flex;\n        flex: 1;\n        flex-direction: column;\n        // height: 100%;\n        padding-inline: 32px;\n        padding-block: 24px;\n        overflow: auto;\n        background: inherit;\n        align-items: center;\n    }\n    .login-wrap {\n        flex: 1 1 0%;\n        padding: 32px 0px;\n    }\n\n    .login-form {\n        width: 328px;\n        min-width: 280px;\n        max-width: 75vw;\n    }\n}\n\n\n.beian {\n    text-align: center;\n    color: #aaa;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
